import { IsNotEmpty, MaxLength, Validate, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';

export class LanguageDataService extends DataService<typeof Model.Core.Logic.ViewModels.LanguageItem, Model.Core.Logic.ViewModels.LanguageItem, LanguageItem> {
	protected map(entity: Model.Core.Logic.ViewModels.LanguageItem): LanguageItem {
		return new LanguageItemModel(entity);
	}

	public static make(ctx?: any): LanguageDataService {
		return new LanguageDataService(ctx, ctx => ctx.Languages);
	}

	public add(defaultLanguage: string) {
		const entity = new Model.Core.Logic.ViewModels.LanguageItem();
		(entity as any).dynamicProperties['displayName'] = { [defaultLanguage]: '' };
		return entity;
	}
}

export class LanguageItemModel extends EntityModel<Model.Core.Logic.ViewModels.LanguageItem, LanguageItem> implements LanguageItem {

	@property<LanguageItemModel>(o => o.entity.languageCode, (o, value) => o.entity.languageCode = value)
	@IsNotEmpty({ message: 'code is required' })
	@IsDefined({ message: 'code is required' })
	@MaxLength(2, { message: 'code is to long' })
	public languageCode: string;

	@property<LanguageItemModel>(o => o.entity.flag, (o, value) => o.entity.flag = value)
	public flag: Uint8Array;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(DisplayNameValidation, ['en'])
	public dynamicProperties: {};
}



// WEBPACK FOOTER //
// ./src/app/general/language/form/language-form.data.ts